import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import css from './List.module.css';
import { IconArrow } from '../../../components';

const List = ({ className, rootClassName, config, onLinkClick }) => {
  const classes = classNames(rootClassName || css.root, className);
  const menu = config.config.navConfig;
  const asideConfig = config.config.aside;
  const fallbackLink = config.config.fallbackLink;

  return (
    <div className={classes}>
      <div className={css.menuSection}>
        {menu.map(m => (
          <div key={m.id} className={css.menu}>
            <h3 className={css.menuHeading}>{m.label}</h3>
            <ul>
              {m.config.map(item => (
                <li key={item.id || item.label}>
                  {/*
                    Always render an anchor. A menu entry that looks like a
                    link but is a <span> is not keyboard reachable and gives
                    no feedback on click.
                  */}
                  <a href={item.link || fallbackLink || '#'} onClick={onLinkClick}>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}

        {asideConfig && (
          <aside className={css.aside}>
            <h3 className={css.title}>{asideConfig.title}</h3>
            <p className={css.description}>{asideConfig.description}</p>
            <div className={css.image}>
              <img src={asideConfig.image} alt={asideConfig.imageAlt} loading="lazy" />
            </div>
            <div className={css.asideLink}>
              <a href={asideConfig.link.link} onClick={onLinkClick}>
                {asideConfig.link.label}
                <IconArrow direction="right" size="small" aria-hidden="true" />
              </a>
            </div>
          </aside>
        )}
      </div>
    </div>
  );
};

List.propTypes = {
  rootClassName: PropTypes.string,
  className: PropTypes.string,
  onLinkClick: PropTypes.func,
  config: PropTypes.shape({
    config: PropTypes.shape({
      navConfig: PropTypes.array.isRequired,
      aside: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        image: PropTypes.string,
        imageAlt: PropTypes.string,
        link: PropTypes.shape({ link: PropTypes.string, label: PropTypes.string }),
      }),
    }),
  }).isRequired,
};

export default List;